import wechatInternalShare from '@phenix/wechat-internal-share';
import initWebLog from '@phenix/web-log';

const log = initWebLog('WEB_GUANGYIN', {}, {}, false);

export default (option = {}, config = {}) => {
    const common = {
        customProduct: 'WEB_GUANGYIN',
    };

    const loadScriptError = url => {
        log.click('WECHAT_SHARE_ERROR', {
            url,
            customCode: 1,
            customMessage: '微信JSSDK加载失败',
            ...common,
        });
    };
    const postSignError = error => {
        log.click('WECHAT_SHARE_ERROR', {
            ...error,
            customCode: 2,
            customMessage: '签名接口请求失败',
            ...common,
        });
    };
    const getSignError = (config, data) => {
        log.click('WECHAT_SHARE_ERROR', {
            config,
            data,
            customCode: 3,
            customMessage: '获取签名失败',
            ...common,
        });
    };
    const configError = config => {
        log.click('WECHAT_SHARE_ERROR', {
            ...config,
            customCode: 4,
            customMessage: '微信JSSDK配置失败',
            ...common,
        });
    };
    const apiError = error => {
        log.click('WECHAT_SHARE_ERROR', {
            ...error,
            customCode: 5,
            customMessage: '微信分享接口设置失败',
            ...common,
        });
    };

    wechatInternalShare(
        {
            loadScriptError,
            postSignError,
            getSignError,
            configError,
            // debug: true,
            appId: 'wxd5a67799d3e3a1f8', 
            app: 'highsheng',
            ...config
        },
        {
            apiError,
            ...option
        },
    );
};